<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.obstetricConsultations', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<!--                <div class="card-title" v-if="can">-->
<!--                    <router-link :to="{ name: 'add-consultation-obstetric' }">-->
<!--                        {{ $t('message.add') }}-->

<!--                        <i class="fas fa-plus-circle edit-icon"></i>-->
<!--                    </router-link>-->
<!--                </div>-->

                <template v-if="rows">

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mConsultations"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="obstetrics-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mConsultations"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" v-if="data.item.isAuthor || hasAdminRole">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-consultation-obstetric', params: { consultation: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.obstetricConsultations', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.numero_grossesse }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteConsultation(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="obstetrics-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Obstetrics",

        computed: {
            ...mapGetters(["obstetricConsultations",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole',
            ]),

            mConsultations: function() {
                let cArray = [];
                _.forEach(this.obstetricConsultations, function(consultation) {
                    let c = {};
                    if (typeof consultation.user == 'object'){
                        let user = consultation.user;
                        let nom = user.prenom ? user.prenom+' ' : '' + user.nom ? user.nom :'';
                        let dossier = consultation.dossier;
                        c.nom_et_dossier =  nom+ ' ( '+ dossier.numero_dossier + ' )';
                    }

                    c.ddr = moment(consultation.ddr).format('DD-MM-YYYY');
                    c.date_creation = moment(consultation.date_creation).format('DD-MM-YYYY');
                    c.numero_grossesse = consultation.numero_grossesse;
                    c.serologie = consultation.serologie;
                    c.groupe_sanguin = consultation.groupe_sanguin;
                    c.statut = consultation.statut_socio_familiale;
                    c.assuetudes = consultation.assuetudes;
                    c.antecedents = consultation.antecedent_de_transfusion;
                    c.risque = consultation.facteur_de_risque;
                    c.date = moment(consultation.created_at).format('DD-MM-YYYY HH:mm');
                    c.id = consultation.id;
                    c.slug = consultation.slug;
                    c.isAuthor = consultation.isAuthor;
                    c.antecedentSpouse = consultation.antecedent_conjoint;
                    cArray.push(c);
                });

                return cArray;
            },

            rows: function() {
                return this.mConsultations.length;
            },
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
        },

        data() {
            return {
                perPage: 8,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'nom_et_dossier',
                        label: this.$i18n.tc('message.nameAndFileNumber'),
                        sortable: true
                    },
                    {
                        key: 'numero_grossesse',
                        label: this.$i18n.t('message.pregnancyNumber'),
                    },
                    {
                        key: 'groupe_sanguin',
                        label: this.$i18n.t('message.bloodGroup'),
                    },
                    // {
                    //     key: 'risque',
                    //     label: this.$i18n.t('message.riskFactor'),
                    // },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key:  'action',
                        label:this.$i18n.tc('message.operations', 1)
                    },

                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getConsultations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getObstetricConsultations', { args : args });
            },
            formattedDisplay (result) {
                return result.nom_et_dossier+' '+result.numero_grossesse;
            },

            itemSelected(item) {
                this.$router.push({ name: 'consultation-obstetric', params: { consultation: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'consultation-obstetric', params: { consultation: items[0].slug } });
            },

            deleteConsultation(consultation) {
                let self = this;

                let args = {
                    consultation: consultation
                };

                let successMessage = this.$i18n.t('message.obstetricConsultationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteObstetricConsultation', { args, index: consultation, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + consultation);
                    });
            }
        },

        mounted() {
            // Fetch obstetric consultation list
            this.getConsultations();
        }
    }
</script>

<style scoped>

</style>